import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openUserCard } from '../../actions/userCard/openUserCard';
import { ChatHeaderUserCardButton } from '../../components/ChatHeader/ChatHeaderUserCardButton';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { useCurrentChatCompanionData } from '../../hooks';
import { currentOpenChatIDSelector } from '../../selectors';
import { userCardIsOpenSelector } from '../../selectors/userCardSelector';

export const ChatHeaderUserCardButtonContainer: React.FC = () => {
  const dispatch = useDispatch();

  const isOpenCard = useSelector(userCardIsOpenSelector);
  const chatId = useSelector(currentOpenChatIDSelector);

  const { companionId } = useCurrentChatCompanionData(chatId);

  const handleClick = () => {
    if (chatId) {
      dispatch(openUserCard(companionId));
    }
  };

  return chatId !== CHATBOT_ID && !isOpenCard ? <ChatHeaderUserCardButton onClick={handleClick} /> : null;
};
